import clsx from 'clsx';
import { graphql } from 'gatsby';
import { Section } from '~components/Section';
import { Image } from '~components/Image';
import { ComponentTrustpilot } from '~components/ComponentTrustpilot';
import * as sharedStyles from '~styles/shared.module.css';
import * as styles from './ContentfulComponentLogoBar.module.css';

import type { ContentBlock } from '~components/types';
import type { ImageType } from '~components/Image';

export type ContentfulComponentLogoBarContent = {
  __typename: 'ContentfulComponentLogoBar';
  images: ImageType[];
};

type ContentfulComponentLogoBarProps = {
  content: ContentfulComponentLogoBarContent;
};

const ContentfulComponentLogoBar: ContentBlock<ContentfulComponentLogoBarProps> = ({ content, ...sectionProps }) => (
  <Section {...sectionProps} className={styles.section}>
    <div className={clsx(sharedStyles.contentWrapper, styles.content)}>
      <ComponentTrustpilot className={styles.trustpilot} />
      <div className={styles.images}>
        {content.images.map((image) => (
          <Image key={image.title} image={image} className={styles.image} />
        ))}
      </div>
    </div>
  </Section>
);

export default ContentfulComponentLogoBar;

export const query = graphql`
  fragment ComponentLogoBar on ContentfulComponentLogoBar {
    __typename
    images {
      ...MixedMedia
    }
  }
`;
